/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';

class RepeatPostControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            repeat: {
                count: 0,
                interval: 0,
                intervalType: 'hours'
            }
        };

        this.updateControlState = this.updateControlState.bind(this);
        this.setRepost = this.setRepost.bind(this);
        this.setRepeatState = this.setRepeatState.bind(this);
    }

    componentDidMount() {

        this.setRepeatState(this.props);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.post.params.repost != this.props.post.params.repost) {
            this.setRepeatState(nextProps);
        }

    }

    setRepeatState(props) {
        let count = 0,
            interval = 0,
            intervalType = 'hours';

        if (this.props.post.params.repost.length > 0) {
            interval = parseInt(this.props.post.params.repost[0], 10);
            if (interval >= 86400) {
                intervalType = 'days';
                interval = interval / 86400;
            } else {
                interval = interval / 3600;
            }
            count = this.props.post.params.repost.length;
        }

        this.setState({
            repeat: {
                count,
                interval,
                intervalType
            }
        });

    }

    updateControlState(e) {
        let repeat = this.state.repeat;

        if (e.currentTarget.dataset.field) {
            switch (e.currentTarget.dataset.field) {
                case 'count':
                    repeat.count = e.currentTarget.value;
                    break;

                case 'interval':
                    repeat.interval = e.currentTarget.value;
                    break;

                case 'intervalType':
                    repeat.intervalType = e.currentTarget.value;
                    break;

                default:
                    break;
            }

            this.setState({
                repeat
            });
        }

    }

    setRepost() {

        let dataEvent = {
    	    	currentTarget: {
    	    		dataset: {
    	    			field: 'post.params.repost'
    	    		}
    	    	},
    	    	target: {
    	    		value: []
    	    	}
            },
            accessoryEvent = {
                currentTarget: {
    	    		dataset: {
    	    			accessory: 'repeat'
    	    		}
    	    	}
            },
            intervalInt = parseInt(this.state.repeat.interval, 10),
            countInt = parseInt(this.state.repeat.count, 10),
            interval = (this.state.repeat.intervalType === 'days') ? intervalInt * 86400 : intervalInt * 3600;

        for (let i = 0; i < countInt; ++i) {
            dataEvent.target.value.push(interval);
        }

        this.props.requestChange(dataEvent);

        this.props.activateAccessory(accessoryEvent);

    }

    render () {
        let countOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            durations = ['hours', 'days'];

        return (
            <div className="panel-content">
                <div className="panel-header">Repeat this post?</div>
                <div className="panel-section">
                    Repeat post <StyledSelect options={countOptions} selectClass="mini" value={this.state.repeat.count} onChange={this.updateControlState} linkedField="count"/> times
                </div>
                <div className="panel-section">
                    Every <StyledSelect options={countOptions} selectClass="mini" value={this.state.repeat.interval} onChange={this.updateControlState} linkedField="interval"/> <StyledSelect options={durations} selectClass="small" value={this.state.repeat.intervalType} onChange={this.updateControlState} linkedField="intervalType"/>
                </div>
                <div className="panel-buttons">
                    <button onClick={this.setRepost} className="btn-secondary">OK</button>
                </div>
            </div>
        );
    }
}

RepeatPostControl.displayName = "RepeatPostControl";

RepeatPostControl.propTypes = {
    panels: PropTypes.object,
    post: PropTypes.object,
    requestChange: PropTypes.func,
    activateAccessory: PropTypes.func
};

RepeatPostControl.defaultProps = {
    panels: {},
    post: {},
    requestChange: null,
    activateAccessory: null
};

export default RepeatPostControl;
